/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import * as qs from 'query-string';

const LandingPage = (props) => { 
    const params = qs.parse(props.location.search);
    const ad = params.ad;
    const bullets = [];
    let heading = '';
    if (ad === "unsigned") {
        heading = "Discover New Unsigned Artists and Bands";
        bullets.push("help music fans discover new unsigned artists and bands and connect with other music fans");
        bullets.push("help promoters find exciting new artists to book for gigs and festivals");
        bullets.push("help record labels and managers discover the hottest unsigned talent");
    }
    else if (ad === "local bands") {
        heading = "Find Local Bands";
        bullets.push("help music fans discover new local artists and bands and connect with other music fans");
        bullets.push("help promoters find exciting local artists to book for gigs and festivals");
        bullets.push("help independent artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "listen to music") {
        heading = "Listen To Music";
        bullets.push("help music fans connect, discover new music and find gigs in their area. Listen to music, watch videos, and decide on what songs and videos appear in the LoudUp charts.");
        bullets.push("help independent artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "new music") {
        heading = "Discover New Music";
        bullets.push("help music fans connect, discover new music and find gigs in their area");
        bullets.push("help independent artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "new bands") {
        heading = "Discover New Bands";
        bullets.push("help music fans connect, discover new bands and find gigs in their area");
        bullets.push("help independent artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "new indie music") {
        heading = "Discover New Indie Music";
        bullets.push("help music fans connect, discover new indie bands and find gigs in their area");
        bullets.push("help promoters find exciting new indie bands to book for gigs and festivals");
        bullets.push("help indie artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "new indie rock music") {
        heading = "Discover New Indie Rock Music";
        bullets.push("help music fans connect, discover new indie rock bands and find gigs in their area");
        bullets.push("help promoters find exciting new indie rock bands to book for gigs and festivals");
        bullets.push("help artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "new indie pop music") {
        heading = "Discover New Indie Pop Music";
        bullets.push("help music fans connect, discover new indie pop bands and find gigs in their area");
        bullets.push("help promoters find exciting new indie pop bands to book for gigs and festivals");
        bullets.push("help artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "new rock music") {
        heading = "Discover New Rock Music";
        bullets.push("help music fans connect, discover new rock bands and find gigs in their area");
        bullets.push("help promoters find exciting new rock bands to book for gigs and festivals");
        bullets.push("help artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "new alternative music") {
        heading = "Discover New Alternative Music";
        bullets.push("help music fans connect, discover new alternative bands and find gigs in their area");
        bullets.push("help promoters find exciting new alternative bands to book for gigs and festivals");
        bullets.push("help artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "new indie folk music") {
        heading = "Discover New Indie Folk Music";
        bullets.push("help music fans connect, discover new indie folk bands and find gigs in their area");
        bullets.push("help promoters find exciting new indie folk bands to book for gigs and festivals");
        bullets.push("help artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    else if (ad === "promote music") {
        heading = "Promote Your Music";
        bullets.push("help independent artists and bands promote their music and connect with new fans, other artists and industry professionals. Expand your network!");
        bullets.push("help music fans connect, discover new music and find gigs in their area");
    }
    else if (ad === "find producer") {
        bullets.push("help independent artists and bands connect with producers, musicians, fans and industry professionals");
        bullets.push("help music fans connect, discover new music and find gigs in their area");
    }
    else {
        bullets.push("help music fans connect, discover new music and find gigs in their area");
        bullets.push("help independent artists and bands promote their music and connect with fans, other artists and industry professionals");
    }
    return (
        <div className="main">
            <MetaTags>       
                <title>{heading ? `${heading} - LoudUp - Intro` : `Intro - LoudUp`}</title>     
                <meta name="robots" content="noindex" />
            </MetaTags>
            <div className="container">
                <article className="block-inner body-why">
                    <header className="why-bgimg">
                        <div className="col-md-8 col-md-push-2 col-sm-10 col-sm-push-1">
                            {
                                heading ?
                                    <React.Fragment>
                                        <h1 className="heading">{heading}</h1>
                                        <h2>What is LoudUp?</h2>
                                    </React.Fragment>
                                : 
                                    <h1>What is LoudUp?</h1>
                            }
                            <div className="introbox">
                                <img src={require('../../Images/picto-whatisloudup-alt.png')} alt="What is LoudUp?" className="picto" />
                                <p className="intro">LoudUp is a brand new music social network designed to:</p>
                                <ul className="list-unstyled">
                                    {
                                        bullets.map((bullet, index) => 
                                            <li key={index}>{bullet}</li>
                                        )
                                    }
                                </ul>
                                <Link to="/Account/Signup?landing = true" className="btn btn-primary btn-createaccount transition">SIGN UP FREE</Link>
                            </div>
                        </div>
                    </header>
                    <div className="row">
                        <div className="col-md-8 col-md-push-2 col-sm-10 col-sm-push-1">
                            {
                                heading ?
                                <h2>Why should I join?</h2>
                                : <h1>Why should I join?</h1>
                            }
                            <ul className="list-unstyled list-why">
                                <li>
                                    <div className="circicon">
                                        <svg className="icon icon-smaller transition">
                                            <use xlinkHref="#icn-fan" />
                                        </svg>
                                    </div>
                                    <h3>Fans</h3>
                                    <p>Discover exciting, new, emerging artists and bands. Connect with other music fans over a shared music taste, support the artists that you love, and find gigs in your area.</p>
                                </li>
                                <li>
                                    <div className="circicon">
                                        <svg className="icon transition">
                                            <use xlinkHref="#icn-artist" />
                                        </svg>
                                    </div>
                                    <h3>Artists</h3>
                                    <p>Showcase your music, videos, and upcoming gigs. Connect with fans, other artists, and industry professionals.</p>
                                </li>
                                <li>
                                    <div className="circicon">
                                        <svg className="icon transition">
                                            <use xlinkHref="#icn-promotor2" />
                                        </svg>
                                    </div>
                                    <h3>Promoters</h3>
                                    <p>Find local talent and increase your bookings.</p>
                                </li>
                                <li>
                                    <div className="circicon">
                                        <svg className="icon icon-smaller transition">
                                            <use xlinkHref="#icn-producer" />
                                        </svg>
                                    </div>
                                    <h3>Producers, Musicians and Songwriters</h3>
                                    <p>Showcase your work and connect with artists and bands looking for your services.</p>
                                </li>
                                <li>
                                    <div className="circicon">
                                        <svg className="icon transition">
                                            <use xlinkHref="#icn-venue2" />
                                        </svg>
                                    </div>
                                    <h3>Recording Studios and Venues</h3>
                                    <p>Promote your place and increase your bookings</p>
                                </li>
                                <li>
                                    <div className="circicon">
                                        <svg className="icon transition">
                                            <use xlinkHref="#icn-manager" />
                                        </svg>
                                    </div>
                                    <h3>Managers and Record Labels</h3>
                                    <p>Advertise your services and showcase your artists.</p>
                                </li>
                            </ul>
                            <div className="ctablock">
                                <div className="btnout">
                                    <Link to="/Account/Signup?landing=true" className="btn btn-primary btn-block transition">SIGN UP FREE</Link>
                                </div>
                                <p>It takes just a couple of minutes</p>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    );
};

LandingPage.propTypes = {
    location: PropTypes.object.isRequired
};

export default LandingPage;